import { useContext } from "react";
import MainContext from "utils/context/MainContext";

const useMainContext = () => {
    return useContext(MainContext);
}

export default useMainContext;